export const Accountant = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5767_3358)">
      <path
        d="M2.75 8.5C3.16421 8.5 3.5 8.16421 3.5 7.75C3.5 7.33579 3.16421 7 2.75 7C2.33579 7 2 7.33579 2 7.75C2 8.16421 2.33579 8.5 2.75 8.5Z"
        fill="#706A85"
      />
      <path
        d="M9.5 1.5H2.5C1.8372 1.50079 1.20178 1.76444 0.73311 2.23311C0.264441 2.70178 0.000793929 3.3372 0 4L0 8C0.000793929 8.6628 0.264441 9.29822 0.73311 9.76689C1.20178 10.2356 1.8372 10.4992 2.5 10.5H9.5C10.1628 10.4992 10.7982 10.2356 11.2669 9.76689C11.7356 9.29822 11.9992 8.6628 12 8V4C11.9992 3.3372 11.7356 2.70178 11.2669 2.23311C10.7982 1.76444 10.1628 1.50079 9.5 1.5ZM2.5 2.5H9.5C9.89782 2.5 10.2794 2.65804 10.5607 2.93934C10.842 3.22064 11 3.60218 11 4H1C1 3.60218 1.15804 3.22064 1.43934 2.93934C1.72064 2.65804 2.10218 2.5 2.5 2.5ZM9.5 9.5H2.5C2.10218 9.5 1.72064 9.34196 1.43934 9.06066C1.15804 8.77936 1 8.39782 1 8V5H11V8C11 8.39782 10.842 8.77936 10.5607 9.06066C10.2794 9.34196 9.89782 9.5 9.5 9.5Z"
        fill="#706A85"
      />
      <rect
        width="5.50015"
        height="5"
        transform="translate(6.5 6)"
        fill="#F8F8F8"
      />
      <path
        d="M8.55265 8.92053C7.66479 9.00078 6.98836 9.75101 7.00015 10.6424V10.6876C7.00015 10.8602 7.14006 11.0001 7.31265 11.0001C7.48524 11.0001 7.62515 10.8602 7.62515 10.6876V10.6299C7.61576 10.0826 8.01966 9.61586 8.56265 9.54657C9.13583 9.48974 9.64656 9.90831 9.70339 10.4815C9.70675 10.5154 9.70845 10.5494 9.70848 10.5834V10.6876C9.70848 10.8602 9.84839 11.0001 10.021 11.0001C10.1936 11.0001 10.3335 10.8602 10.3335 10.6876V10.5834C10.3325 9.66193 9.58461 8.91573 8.6631 8.91675C8.62625 8.91679 8.58941 8.91805 8.55265 8.92053Z"
        fill="#706A85"
      />
      <path
        d="M8.66675 8.5C9.3571 8.5 9.91675 7.94035 9.91675 7.25C9.91675 6.55965 9.3571 6 8.66675 6C7.9764 6 7.41675 6.55965 7.41675 7.25C7.41744 7.94007 7.97668 8.49931 8.66675 8.5ZM8.66675 6.625C9.01192 6.625 9.29175 6.90482 9.29175 7.25C9.29175 7.59518 9.01192 7.875 8.66675 7.875C8.32157 7.875 8.04175 7.59518 8.04175 7.25C8.04175 6.90482 8.32157 6.625 8.66675 6.625Z"
        fill="#706A85"
      />
      <path
        d="M11.6875 8.0835H11.375V7.771C11.375 7.59841 11.2351 7.4585 11.0625 7.4585C10.8899 7.4585 10.75 7.59841 10.75 7.771V8.0835H10.4375C10.2649 8.0835 10.125 8.22341 10.125 8.396C10.125 8.56858 10.2649 8.7085 10.4375 8.7085H10.75V9.021C10.75 9.19358 10.8899 9.3335 11.0625 9.3335C11.2351 9.3335 11.375 9.19358 11.375 9.021V8.7085H11.6875C11.8601 8.7085 12 8.56858 12 8.396C12 8.22341 11.8601 8.0835 11.6875 8.0835Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_5767_3358">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
